import { Injectable, Inject } from '@angular/core';
import { AppSettings } from '../api/models/appSettings';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })

};

@Injectable()
export class ConfigurationService {

    appSettings: AppSettings;

    constructor(@Inject(HttpClient) private httpclient: HttpClient) {
        this.appSettings = new AppSettings();
    }

    getConfiguration(apiurl: string): Observable<any> {
        let url = apiurl;
        return this.httpclient.get<any>(url, httpOptions);
    }
}